module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_login-d2841a9ffa0cd7ec338fac46f6c5e4fd.jpg";